import type { SessionUser } from '../../shared/types'
import { buildFrame } from '../frame'
import { internalLink } from '../router'
import { h } from '../ui'

export function notFoundView(
  root: HTMLElement,
  user: SessionUser | null,
  message = 'Nothing on the menu at this address.',
): () => void {
  const frame = buildFrame({ user, subbar: false })
  frame.stage.append(
    h('div', { class: 'notice' }, [
      h('h1', {}, ['404 — not on the menu']),
      h('p', {}, [message]),
      h('div', { class: 'actions' }, [
        h('a', { class: 'control', ...internalLink('/') }, ['Start a new pasta']),
      ]),
    ]),
  )
  frame.statusLeft.textContent = 'pastabin'
  root.append(frame.element)
  document.title = 'not found · pastabin'
  return () => {}
}
